import { IconButton, styled, ToggleButton, Typography } from '@mui/material'
import React, { useState } from 'react'
import IosShareRoundedIcon from "@mui/icons-material/IosShareRounded";
import { BookingsFilterValues } from './schema/BookingFiltersType';
import { useBookings } from '../modules/booking/queries/useBookings';
import axiosInstance from '../services/axios';
import qs from "qs";
import * as XLSX from "xlsx";

interface ExportBookingProps {
  filters?: BookingsFilterValues;
  searchText?: string;
}

const ExportBooking: React.FC<ExportBookingProps> = ({ filters, searchText }) => {

  const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
  const [loading, setLoading] = useState(false);

  const { data: bookingsData } = useBookings({ searchText, filters, ...pagination });
  const totalBookingsCount = bookingsData?.pagination?.total;
  const rowsPerPage = pagination.rowsPerPage;

  const exportBooking = async () => {
    console.log("start")
    setLoading(true);
    const allBookings = await fetchAllBookings();
    setLoading(false);

    const flattenedBookings = allBookings.map((booking) => ({
      id: booking.id,
      documentId: booking.documentId,
      eventName: booking.event?.name || "", 
      exhibitorName: booking.exhibitor?.name || "",// Flatten event name
      invoice: booking.invoice,
      price: booking.price,
      payment_status: booking.payment_status,
      booking_status: booking.booking_status,
      createdAt: booking.createdAt,
      invoiceNumber: booking.invoiceNumber,
      currency: booking.currency,
    }));

    
    // Convert the bookings data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(flattenedBookings);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

    // Export the workbook to an Excel file
    XLSX.writeFile(workbook, "bookings.xlsx");
  };


  const fetchAllBookings = async () => {
    if (!totalBookingsCount) return [];
    const totalPages = Math.ceil(totalBookingsCount / rowsPerPage);
    let allBookings: any[] = [];

    for (let page = 1; page <= totalPages; page++) {
      const response = await fetchBookings({ filters, searchText, page, rowsPerPage });
      allBookings = [...allBookings, ...response.data.data];
    }

    return allBookings;
  };

  const fetchBookings = async ({ filters, searchText, page, rowsPerPage }: { filters?:BookingsFilterValues, searchText?: string, page: number; rowsPerPage: number }) => {
    console.log("page", page)

    const queryObject: any = {
      filters: { ...filters },
      pagination: { page, pageSize: rowsPerPage },
      populate: ['event', 'exhibitor'], 
    };

    if (searchText) {
      queryObject.filters = {
        ...queryObject.filters,
        event: {
          name: {
            $contains: searchText
          }
        }
      };
    }

    const query = qs.stringify(queryObject, { encode: false });
  
    const response = await axiosInstance.get(`/bookings?${query}`);
    if (!response) throw new Error("Failed to fetch bookings");
    return response;
  };

  return (
    <StyledIconButton
    sx={{
      display: { xs: "none", sm: "flex" },
    }}
    onClick={exportBooking}
    disabled={loading}
  >
    <Typography variant="body1" sx={{ mr: 2 }}>
      {loading ? "Exporting..." : 'Export'}
    </Typography>
    <IosShareRoundedIcon />
  </StyledIconButton>
  )
}

export default ExportBooking

const StyledIconButton = styled(IconButton)({
  "&.MuiIconButton-root": {
    backgroundColor: "#fff",
    borderRadius: "25px",
  },
});
